export const BASE_URL = process.env.NODE_ENV === 'production' ? process.env.REACT_APP_API_URL : 'https://127.0.0.1:8000'

const CARS_URL = 'cars'
const PRICING_URL = 'pricing'
const DEALS_URL = 'deals'
const LEADS_URL = 'leads'
const CLIENTS_URL = 'clients'
const EMAILS_URL = 'emails'
const ACCOUNTS_URL = 'accounts'
const LISTINGS_URL = 'listings'
const DEALERSHIPS_URL = 'dealerships'
const CRM_URL = 'crm'
const NOTIFICATIONS_URL = 'notifications'

const CREATE_URL = 'create'
const UPDATE_URL = 'update'
const DELETE_URL = 'delete'

export const URLS = {
    getCSRFCookie: () => `/get_csrf_cookie`,
    logError: () => `/log_error`,

    // Notifications URLS
    getNotifications: (params = '') => params ? `/${NOTIFICATIONS_URL}?${params}` : `/${NOTIFICATIONS_URL}`,
    getNotificationsSummary: () => `/${NOTIFICATIONS_URL}/summary`,
    updateNotification: (id) => `/${NOTIFICATIONS_URL}/${id}`,
    markNotificationsRead: () => `/${NOTIFICATIONS_URL}/mark_read`,

    // Accounts URLS
    login: () =>  `/accounts/login`,
    logout: () => `/accounts/logout`,
    changePassword: () => `/accounts/change_password`,
    requestPasswordReset: () => `/accounts/password_reset`,
    confirmPasswordReset: () => `/accounts/password_reset/confirm`,
    refreshToken: () => `/accounts/token/refresh`,
    // Default Quote Settings
    getDefaultQuoteSettings: () => `/${ACCOUNTS_URL}/quote_settings`,
    updateDefaultQuoteSettings: () => `/${ACCOUNTS_URL}/quote_settings/update`,

    //CAR URLS
    makesForYear: (isUsed) => `/${CARS_URL}/?is_used=${isUsed}`,
    modelsForMake: (year, make, isUsed) => `/${CARS_URL}/${year}/${make}/?is_used=${isUsed}`,
    trimsForModel: (year, make, model, isUsed) => `/${CARS_URL}/${year}/${make}/${model}/?is_used=${isUsed}`,
    getCarByVin: (vin, isUsed) => `/${CARS_URL}/${vin}/?is_used=${isUsed}`,

    // PRICING URLS
    getPricingsForMake: (make, params) => params ? `/${PRICING_URL}/${make}?${params}` : `/${PRICING_URL}/${make}`,
    createPricing: (make) => `/${PRICING_URL}/${CREATE_URL}`,
    updatePricing: (id) => `/${PRICING_URL}/${id}/${UPDATE_URL}`,
    deletePricing: (id) => `/${PRICING_URL}/${id}/${DELETE_URL}`,

    // DEAL URLS
    getDeal: (id, params) => params ? `/${DEALS_URL}/${id}?${params}` : `/${DEALS_URL}/${id}`,
    getDeals: (params) => params ? `/${DEALS_URL}?${params}` : `/${DEALS_URL}`,
    createDeal: () => `/${DEALS_URL}/${CREATE_URL}`,
    updateDeal: (id) => `/${DEALS_URL}/${id}/${UPDATE_URL}`,
    deleteDeal: (id) => `/${DEALS_URL}/${id}/${DELETE_URL}`,
    getPDF: (id) => `/${DEALS_URL}/${id}/pdf`,
    getDealListings: (id, params) => params ? `/${DEALS_URL}/${id}/listings?${params}` : `/${DEALS_URL}/${id}/listings`,

    // Tax regions. A ZIP can straddle more than one MarketScan tax region; this
    // runs at ZIP-entry time and needs no deal. A chosen region is applied
    // through the ordinary deal update, as `tax_region_id` alongside the
    // location it belongs to — there is no separate selection endpoint.
    getTaxRegions: (zipcode) => `/${DEALS_URL}/tax_regions?zipcode=${encodeURIComponent(zipcode)}`,

    // Desking
    getDesking: () => `/${DEALS_URL}/desking`,
    getRebates: () => `/${DEALS_URL}/rebates`,
    getRebateCompatibilities: () => `/${DEALS_URL}/rebate_compatibilities`,
    getRebate: (rebateId) => `/${DEALS_URL}/get_rebate/${rebateId}`,

    // Listings
    getListings: () => `/${LISTINGS_URL}`,
    getListing: (id) => `/${LISTINGS_URL}/${id}`,
    searchCars: () => `/${LISTINGS_URL}/search`,
    suggestListings: (q) => `/${CARS_URL}/suggest/?q=${encodeURIComponent(q)}`,

    // Saved Dealerships
    getSavedDealerships: () => `/${DEALERSHIPS_URL}`,
    searchDealerships: (params) => params ? `/${DEALERSHIPS_URL}/search?${params}` : `/${DEALERSHIPS_URL}/search`,
    saveDealership: () => `/${DEALERSHIPS_URL}/save`,
    deleteSavedDealership: (id) => `/${DEALERSHIPS_URL}/${id}/delete`,

    // PROFILE URLS
    // Location
    getProfile: () => `/accounts/profile`,
    updateProfile: () => `/accounts/profile/update`,
    accountLogo: () => `/accounts/profile/logo`,
    getLocations: () => `/accounts/locations`,
    createLocation: () => `/accounts/location`,
    updateLocation: (id) => `/accounts/location/${id}/${UPDATE_URL}`,
    deleteLocation: (id) => `/accounts/location/${id}`,

    // Leads
    getLead: (id, params) => params ? `/${LEADS_URL}/${id}?${params}` : `/${LEADS_URL}/${id}`,
    getLeads: (params) => params ? `/${LEADS_URL}?${params}` : `/${LEADS_URL}`,
    createLead: () => `/${LEADS_URL}/${CREATE_URL}`,
    updateLead: (id) => `/${LEADS_URL}/${id}/${UPDATE_URL}`,
    deleteLead: (id) => `/${LEADS_URL}/${id}/${DELETE_URL}`,
    uploadLeadsCSV: () => `/${LEADS_URL}/upload_csv`,
    bulkUploadLeads: () => `/${LEADS_URL}/bulk_upload`,
    exportLeads: () => `/${LEADS_URL}/export`,

    // Clients
    getClient: (id, params) => params ? `/${CLIENTS_URL}/${id}?${params}` : `/${CLIENTS_URL}/${id}`,
    getClients: (params) => params ? `/${CLIENTS_URL}?${params}` : `/${CLIENTS_URL}`,
    createClient: () => `/${CLIENTS_URL}/${CREATE_URL}`,
    updateClient: (id) => `/${CLIENTS_URL}/${id}/${UPDATE_URL}`,
    deleteClient: (id) => `/${CLIENTS_URL}/${id}/${DELETE_URL}`,
    bulkUploadClients: () => `/${CLIENTS_URL}/bulk_upload`,
    exportClients: () => `/${CLIENTS_URL}/export`,

    // Emails
    createEmail: () => `/${EMAILS_URL}/${CREATE_URL}`,

    // CRM — Person / Opportunity / Stage (new pipeline model). These use REST
    // verbs on the resource URL (PATCH/DELETE on /<id>), not /update /delete.
    getCrmPeople: (params) => params ? `/${CRM_URL}/people?${params}` : `/${CRM_URL}/people`,
    getCrmPerson: (id) => `/${CRM_URL}/people/${id}`,
    createCrmPerson: () => `/${CRM_URL}/people`,
    updateCrmPerson: (id) => `/${CRM_URL}/people/${id}`,
    deleteCrmPerson: (id) => `/${CRM_URL}/people/${id}`,
    bulkDeleteCrmPeople: () => `/${CRM_URL}/people/bulk_delete`,
    bulkMarkDeadCrmPeople: () => `/${CRM_URL}/people/bulk_mark_dead`,
    getCrmHouseholds: (params) => params ? `/${CRM_URL}/households?${params}` : `/${CRM_URL}/households`,
    createCrmHousehold: () => `/${CRM_URL}/households`,
    addCrmHouseholdMembers: (id) => `/${CRM_URL}/households/${id}/add_members`,
    removeCrmHouseholdMembers: (id) => `/${CRM_URL}/households/${id}/remove_members`,
    crmHousehold: (id) => `/${CRM_URL}/households/${id}`,

    getCrmStages: () => `/${CRM_URL}/stages`,
    createCrmStage: () => `/${CRM_URL}/stages`,
    updateCrmStage: (id) => `/${CRM_URL}/stages/${id}`,
    deleteCrmStage: (id) => `/${CRM_URL}/stages/${id}`,
    reorderCrmStages: () => `/${CRM_URL}/stages/reorder`,

    previewCrmImport: () => `/${CRM_URL}/imports/preview`,
    commitCrmImport: () => `/${CRM_URL}/imports/commit`,

    getCrmReports: (params) => params ? `/${CRM_URL}/reports?${params}` : `/${CRM_URL}/reports`,
    getCrmSettings: () => `/${CRM_URL}/settings`,
    runCrmRenewals: () => `/${CRM_URL}/renewals/run`,

    getCrmOpportunities: (params) => params ? `/${CRM_URL}/opportunities?${params}` : `/${CRM_URL}/opportunities`,
    getCrmOpportunityCounts: (params) => params ? `/${CRM_URL}/opportunities/counts?${params}` : `/${CRM_URL}/opportunities/counts`,
    getCrmOpportunity: (id) => `/${CRM_URL}/opportunities/${id}`,
    createCrmOpportunity: () => `/${CRM_URL}/opportunities`,
    updateCrmOpportunity: (id) => `/${CRM_URL}/opportunities/${id}`,
    moveCrmOpportunity: (id) => `/${CRM_URL}/opportunities/${id}/move`,
    deleteCrmOpportunity: (id) => `/${CRM_URL}/opportunities/${id}`,
    attachCrmQuote: (id) => `/${CRM_URL}/opportunities/${id}/attach_quote`,
    removeCrmOpportunityVehicle: (id) => `/${CRM_URL}/opportunities/${id}/remove_vehicle`,
    reverseCrmOpportunitySale: (id) => `/${CRM_URL}/opportunities/${id}/reverse_sale`,
    editCrmOpportunitySale: (id) => `/${CRM_URL}/opportunities/${id}/edit_sale`,
    deleteCrmOpportunitySale: (id) => `/${CRM_URL}/opportunities/${id}/delete_sale`,
    purchaseCrmOpportunityVehicle: (id) => `/${CRM_URL}/opportunities/${id}/purchase_vehicle`,

    getCrmVehicles: (params) => params ? `/${CRM_URL}/vehicles?${params}` : `/${CRM_URL}/vehicles`,
    createCrmVehicle: () => `/${CRM_URL}/vehicles`,
    updateCrmVehicle: (id) => `/${CRM_URL}/vehicles/${id}`,
    deleteCrmVehicle: (id) => `/${CRM_URL}/vehicles/${id}`,
    purchaseCrmVehicle: (id) => `/${CRM_URL}/vehicles/${id}/purchase`,

    getCrmActivities: (params) => params ? `/${CRM_URL}/activities?${params}` : `/${CRM_URL}/activities`,
    createCrmActivity: () => `/${CRM_URL}/activities`,
    deleteCrmActivity: (id) => `/${CRM_URL}/activities/${id}`,
}